<!-- 学习潜力 -->
<template>
    <div class="page_part1">
        <div class="page_shadow page_main">
            <TopHeader :title="'学习潜力评估结果'" :headerLogo="headerLogo"></TopHeader>
            <h5 class="header page_header">
                <span>Part.2 学习潜力</span>
            </h5>
            <h6 class="page_title_2">
                <span>学习潜力</span>
                <span class="arrow"></span>
            </h6>
            <div class="header_detail_box">
                <p class="header_detail">学习潜力由进行学习活动时所运用到的能力所构成。学习力测评通过对与学习活动相关的9项基本能力进行测试，并与测评者同龄群体平均水平进行对比来评估测评者的学习潜力。</p>
                <p class="header_detail">9项基本能力包括：注意力、信息加工能力、工作记忆能力、思维转换能力、逻辑推理能力、数学能力、表象能力、空间能力、语言能力。</p>
            </div>
            <p class="page_title_3" :style="{marginBottom: '50px'}">
                <img src="~@/assets/report2_imgs/icon_fc.png" alt="">
                学习潜力评估结果
            </p>
            <div class="main_box main_box_part2">
                <div class="main_norm_box">
                    <div class="norm_box" :style="{width: norm_total.score/200*692  + 'px'}" >
                        <div class="norm_score">
                            <p class="score">{{norm_total.score | toFixed(1)}}</p>
                        </div>
                        <div class="norm_block norm_block_part2" :style="{left: normData.l_norm/200*692 + 'px', width: (normData.r_norm-normData.l_norm)/200*692 + 'px' }" :title="normData.l_norm + '~' +normData.r_norm"></div>
                    </div>
                </div>
                <div class="result_box">
                    <div class="you">
                        <p class="title">优&ensp;势&ensp;项</p>
                        <p class="detailBox"><span v-for="(item,index) in core.potentialAdvantage" :key="index">{{item}}</span></p>
                    </div>
                    <div class="lie">
                        <p class="title">待发展项</p>
                        <p class="detailBox"><span v-for="(item,index) in core.potentialDisadvantage" :key="index">{{item}}</span></p>
                    </div>
                </div>
                <!--<p class="main_remark"><span class="remark">备注</span>本测评水平值范围0~5，{{normObj.name}}平均水平值为<span class="c_orange">{{normObj.l_norm}}~{{normObj.r_norm}}</span>。</p>-->
                <!--<P class="main_directions">{{comment}}</P>-->
            </div>
            <div class="echartsBox">
                <div id="echart_qianli_radar" :style="{width: '710px',height: '450px'}"></div>
                <div class="norm"></div>
            </div>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main" v-if="comment">
            <TopHeader :title="'学习潜力分析'" :headerLogo="headerLogo"></TopHeader>
            <p class="page_title_3">
                <img src="~@/assets/report2_imgs/icon_fc.png" alt="">
                学习潜力分析
            </p>
            <!--注意力-->
            <ThePart1Main :index="1" :normData="normData" :normObj="norm_copy[8]" :comment="comment[norm_copy[8].type].comment" ></ThePart1Main>
            <!-- 信息加工能力 -->
            <ThePart1Main :index="2" :normData="normData" :normObj="norm_copy[0]" :comment="comment[norm_copy[0].type].comment" ></ThePart1Main>
            <!-- 工作记忆能力 -->
            <ThePart1Main :index="3" :normData="normData" :normObj="norm_copy[1]" :comment="comment[norm_copy[1].type].comment" ></ThePart1Main>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main" v-if="comment">
            <TopHeader :title="'学习潜力分析'"  :headerLogo="headerLogo"></TopHeader>
            <!-- 思维转换能力 -->
            <ThePart1Main :index="4" :normData="normData" :normObj="norm_copy[4]" :comment="comment[norm_copy[4].type].comment" ></ThePart1Main>
            <!-- 逻辑推理能力 -->
            <ThePart1Main :index="5" :normData="normData" :normObj="norm_copy[5]" :comment="comment[norm_copy[5].type].comment" ></ThePart1Main>
            <!-- 数学能力 -->
            <ThePart1Main :index="6" :normData="normData" :normObj="norm_copy[7]" :comment="comment[norm_copy[7].type].comment" ></ThePart1Main>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main" v-if="comment">
            <TopHeader :title="'学习潜力分析'" :headerLogo="headerLogo"></TopHeader>
            <!-- 表象能力 -->
            <ThePart1Main :index="7" :normData="normData" :normObj="norm_copy[3]" :comment="comment[norm_copy[3].type].comment" ></ThePart1Main>
            <!-- 数学能力 -->
            <ThePart1Main :index="8" :normData="normData" :normObj="norm_copy[2]" :comment="comment[norm_copy[2].type].comment" ></ThePart1Main>
            <!-- 数学能力 -->
            <ThePart1Main :index="9" :normData="normData" :normObj="norm_copy[6]" :comment="comment[norm_copy[6].type].comment" ></ThePart1Main>
            <p class="big_page_number"></p>
        </div>
    </div>
</template>
<script>
import TopHeader from './TopHeader.vue';//页眉
import ThePart1Main from './ThePart1Main.vue';//目录
export default {
    name: 'page_part1',
    components: { TopHeader,ThePart1Main },
    props: {
        headerLogo: {},
        core: {},
        normData: {
        },
        norm: {
            type: Array//norm数组的其中一项
            // required: true
        },
        comment: {
            type: Object//comment的类型解读
            // required: true
        },
        partIndex: {
            type: Number
        }
    },
    data() {
        return {
            // comment: null,  //info    work        space    present  think          logic       lang      math
            // norm: [] //
        }
    },
    computed: {
        part1NormSort() {
            let arr = [];
            let part1Norm = this.norm;
            // 0信息加工能力 1工作记忆能力 2空间能力 3表象能力 4思维转换能力 5逻辑推理能力 6语言能力 7数学能力 8注意力
            // 注意力，信息加工能力，工作记忆能力，思维转换能力，逻辑推理能力，数学能力，表象能力，空间能力，语言能力
            arr[0]=part1Norm[8];
            arr[1]=part1Norm[6];
            arr[2]=part1Norm[2];
            arr[3]=part1Norm[3];
            arr[4]=part1Norm[7];
            arr[5]=part1Norm[5];
            arr[6]=part1Norm[4];
            arr[7]=part1Norm[1];
            arr[8]=part1Norm[0];
            return arr;
        },
        norm_copy() {
            return this.norm.slice(0,9);
        },
        norm_total() {
            return this.norm[9];
        }
    },
    watch: {
    },
    created() {
    },
    mounted() {
        let norm = this.part1NormSort;
        let indicatorData = [];
        let seriesData = [];
        let colorList = [];
        norm.forEach((value,index)=>{
            let obj= {};
            obj.text = value.name;
            obj.max = 200;
            obj.color = this.getEchartColor(value.score);
            obj.grade = this.getGrade(value.score)
            indicatorData.push(obj);
            seriesData.push(Number(value.score.toFixed(1)));
        })
        this.createEcharts(indicatorData,seriesData);

    },
    methods: {
        getEchartColor(value) {
            if(0<value&&value<75) {
                return 'c1'
            }else if (75<=value&&value<92){
                return 'c2'
            }else if (92<=value&&value<108){
                return 'c3'
            }else if (108<=value&&value<125){
                return 'c4'
            }else{
                return 'c5'
            }
        },
        createEcharts(indicatorData,seriesData) {
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('echart_qianli_radar'));
            // 指定图表的配置项和数据
            let option = {
                radar: {
                    indicator: indicatorData,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#D9D9D9',
                            type: 'dashed',
                            width: 1
                        },
                    },
                    axisLabel: {
                        showMaxLabel: true,
                        // textStyle: {fontSize: 18, color: '#333'}
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#D9D9D9',
                            type: 'dashed',
                            width: 1
                        }
                    },
                    axisTick: {
                        show: true,
                        length: 0
                    },
                    splitNumber: 8,
                    name: {
                        color: '#000',
                        fontSize: 15,
                        // formatter: [
                        //     '{a|vlaue}',
                        //     '{b|这段文本采用样式b}这段用默认样式{x|这段用样式x}'
                        // ].join('\n'),

                        formatter: function (params, obj) {
                            return [
                                '{a|' + obj.text + '}',
                                '{a|水平：}' + '{' + obj.color + '|' + obj.grade + '}'
                            ].join('\n')
                        },
                        rich: {
                            a: {
                                color: '#333',
                                fontSize: 14,
                                lineHeight: 20,
                                textAlign: 'left'
                            },
                            b: {
                                lineHeight: 20,
                                fontSize: 12,
                                textAlign: 'left'
                            },

                            c1: {
                                color: '#FF0000',
                                fontSize: 12,
                            },
                            c2: {
                                color: '#FFC001',
                                fontSize: 12,
                            },
                            c3: {
                                color: '#1CA4B6',
                                fontSize: 12,
                            },
                            c4: {
                                color: '#92D050',
                                fontSize: 12,
                            },
                            c5: {
                                color: '#00B050',
                                fontSize: 12,
                            }

                        },

                        textStyle: {
                            color: '#333',
                            borderRadius: 3,
                            textStyle: {
                                color: '#72ACD1'
                            }
                        }
                    },

                    splitArea : {
                        show : true,
                        areaStyle : {
                            color: ['transparent', '#EEF8FE','transparent','rgba(121, 119, 119, 0.2)' ,'rgba(121, 119, 119, 0.2)', 'transparent','#EEF8FE','transparent']
                            // 图表背景网格的颜色
                        }
                    },
                },

                calculable: false,
                series: [{
                    type: 'radar',
                    symbol:'circle',
                    data: [
                        {
                            // value: [188,134,165,134,166,177],
                            value: seriesData,
                            name: '学习潜力',
                            areaStyle: {
                                opacity: 0.2,
                                color: '#1CA4B6'
                            },
                            label: {
                                show: true,
                                formatter: function(params,obj) {
                                    return params.value;
                                }
                            }
                        }
                    ],
                    lineStyle:{
                        color:'#1CA4B6'
                    },
                    symbolSize :8,
                    color :"#1CA4B6"
                }],
            }
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },
        getGrade(value) {
            if(0<value&&value<75) {
                return '低'
            }else if (75<=value&&value<92){
                return '较低'
            }else if (92<=value&&value<108){
                return '中等'
            }else if (108<=value&&value<125){
                return '较高'
            }else{
                return '高'
            }
        },
        getColor(value) {
            if(value == 1) {
                return "c_grade1";
            }else if(value == 2) {
                return "c_grade2";
            }else if(value == 3) {
                return "c_grade3";
            }else if(value == 4) {
                return "c_grade4";
            }else {
                return "c_grade5";
            }
        },

    }
}
</script>
<style type="text/css" lang='less' scoped>
@import './report.less';
.page_part1 {
    .circle_box {
        width: 150px;
        text-align: center;
        margin-bottom: 30px;
        .title {
            line-height: 36px;
            color: #8a8a8a;
        }
    }
    .result_box {
        .title {
            width: 76px;
            line-height: 26px;
            font-size: 14px;
            font-weight: bold;
        }
        .you,.lie {
            display: flex;
        }
        .detailBox {
            flex: 1;
            line-height: 26px;
            margin-bottom: 15px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            flex-wrap: wrap;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            span {
                width: 92px;
                height: 26px;
                margin-right: 20px;
                display: inline-block;
                line-height: 26px;
                color: #fff;
                font-size: 12px;
                border-radius: 4px;
                font-weight: normal;
                text-align: center;
                margin-bottom: 10px;
            }
        }
        .you span {
            //background-color: #AACF00;
            background-color: #3AB3C1;
        }
        .lie span {
            //background-color: #31C1F3;
            background-color: #FEAE3B;
        }
    }

    .canvas_box {
        text-align: center;
        position: relative;
        .box {
            position: absolute;
            left: 0;
            top: 30px;
            width: 150px;
            height: 90px;
            font-size: 14px;
            flex-wrap: wrap;
            display: flex;
            align-items: center;
            justify-content: center;
            p {
                width: 100%;
            }
            .score {
                font-size: 20px;
                font-weight: bold;
                color: #F87608;
                line-height: 30px;
            }
        }
    }
    .table_box {
        tr {
            .c_grade1 {
                background-color: #F6B980;
            }
            .c_grade2 {
                background-color: #F08C00;
            }
            .c_grade3 {
                background-color: #E7A53C;
            }
            .c_grade4 {
                background-color: #F87608;
            }
            .c_grade5 {
                background-color: #DF6800;
            }

            th {
                background-color: #41CBAA;
                color: #fff;
                font-size: 16px;
                line-height: 42px;
                background-color: #41CBAA;
                border: 1px solid #fff;
                text-align: center;
            }
            .td_line {
                padding-left: 13px;
            }
            td {
                font-size: 14px;
                line-height: 46px;
                text-align: center;
                background-color: #F7F7F7;
                border: 1px solid #fff;
                .percent_line {
                    width: 200px;
                    height: 20px;
                    position: relative;
                    .lien_norm {
                        height: 26px;
                        position: absolute;
                        top: -3px;
                        background-color: rgba(132,60,0,.4);
                    }
                    .line_score {
                        height: 20px;
                    }
                }
            }
        }
    }
}
</style>
